import { useCallback, useEffect, useState } from 'react'

const konamiSequence = [
  'ArrowUp',
  'ArrowUp',
  'ArrowDown',
  'ArrowDown',
  'ArrowLeft',
  'ArrowRight',
  'ArrowLeft',
  'ArrowRight',
  'b',
  'a',
]

const storageKey = 'konamiCodeActive'

const useKonamiCode = () => {
  const [isActive, setIsActive] = useState(() => localStorage.getItem(storageKey) === 'true')
  const [currentIndex, setCurrentIndex] = useState(0)

  useEffect(() => {
    localStorage.setItem(storageKey, isActive)
  }, [isActive])

  const handleKeyDown = useCallback(
    event => {
      if (event.key === konamiSequence[currentIndex]) {
        const nextIndex = currentIndex + 1

        if (nextIndex === konamiSequence.length) {
          setIsActive(prev => !prev)
          setCurrentIndex(0)

          return
        }

        setCurrentIndex(nextIndex)

        return
      }

      setCurrentIndex(0)
    },
    [currentIndex]
  )

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown)

    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [handleKeyDown])

  return isActive
}

export default useKonamiCode
